import { useQuery } from '@tanstack/react-query'
import axios from '@pepper/utils/src/function/axiosInstance'
import { SEO_SERVICE_BASE_URL } from '@pepper/utils/src/api/config'
import { ApiError } from '@pepper/utils/src/types/domain'

type Props = {
  companyId: string
  uri?: string
  country?: string
  enabled?: boolean
}

const handleFetch = async (
  companyId: string,
  country?: string,
  uri?: string
) => {
  const url = `${SEO_SERVICE_BASE_URL}/companies/${companyId}/integrations/gsc/properties/validate`
  const response = await axios.get(url, {
    params: {
      country_code: country,
      property: uri,
    },
  })
  return response.data
}

export const useGscValidation = ({
  companyId,
  country,
  uri,
  enabled,
}: Props) => {
  const { data, error, isLoading } = useQuery<{ data: boolean }, ApiError>({
    queryKey: ['gsc-validation', companyId, country, uri],
    queryFn: () => handleFetch(companyId, country, uri),
    enabled,
    retry: false,
  })

  return {
    data,
    isLoading,
    error,
  }
}
